<script setup lang="ts">
import { Permission, usePermissionStore } from "@/stores/permission";

const props = defineProps<{
	permission: Permission | Permission[];
}>();

const permissionStore = usePermissionStore();

const hasAccess = computed(() => {
	if (Array.isArray(props.permission)) {
		return props.permission.some((p) => permissionStore.hasPermission(p));
	} else {
		return permissionStore.hasPermission(props.permission);
	}
});
</script>

<template>
	<slot v-if="hasAccess" />
	<slot v-else name="fallback" />
</template>
